/* Liemora – Verzekerd verzenden (opt-in, standaard uit). */
(function(){
  var VARIANT = 58023146488148, PRICE = 335;
  var T = {
    nl: { title: 'Verzekerd verzenden', desc: 'Bij verlies, diefstal of schade sturen we kosteloos een nieuwe.' },
    de: { title: 'Versicherter Versand', desc: 'Bei Verlust, Diebstahl oder Beschädigung senden wir kostenlos Ersatz.' },
    fr: { title: 'Envoi assuré', desc: 'En cas de perte, de vol ou de dommage, nous renvoyons gratuitement.' },
    en: { title: 'Shipping protection', desc: 'If your parcel is lost, stolen or damaged, we send a new one for free.' }
  };
  var lang = (document.documentElement.lang || 'nl').slice(0, 2), t = T[lang] || T.nl;
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;

  var css = '.lp-box{display:flex;align-items:center;gap:12px;margin:0 0 16px;padding:12px 14px;border:1px solid #DCE6D8;border-radius:14px;background:#F1F5EE;transition:background .2s,border-color .2s}' +
    '.lp-box.on{background:#E6EFE2;border-color:#7A9B7A}' +
    '.lp-ic{flex:0 0 38px;height:38px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;color:#526D52}' +
    '.lp-ic svg{width:20px;height:20px}' +
    '.lp-tx{flex:1;min-width:0;line-height:1.3}' +
    '.lp-tx b{display:block;font-size:14px;font-weight:700;color:#2D2D2A}' +
    '.lp-tx b em{font-style:normal;font-weight:600;color:#526D52;margin-left:4px}' +
    '.lp-tx small{display:block;font-size:12.5px;color:#6B6B63;margin-top:2px}' +
    '.lp-sw{position:relative;flex:0 0 46px;height:26px;cursor:pointer}' +
    '.lp-sw input{position:absolute;opacity:0;inset:0;margin:0;cursor:pointer}' +
    '.lp-sw i{position:absolute;inset:0;border-radius:999px;background:#C9C2B4;transition:background .2s}' +
    '.lp-sw i:after{content:"";position:absolute;top:3px;left:3px;width:20px;height:20px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.2);transition:transform .2s}' +
    '.lp-sw input:checked+i{background:#526D52}' +
    '.lp-sw input:checked+i:after{transform:translateX(20px)}' +
    '.lp-sw input:focus-visible+i{outline:2px solid #2D2D2A;outline-offset:2px}' +
    '.lp-box.wait{opacity:.6;pointer-events:none}' +
    '.line.lp-line .qty{visibility:hidden}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var shield = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
  function fmt(c){ try { return new Intl.NumberFormat((document.documentElement.lang || 'nl') + '-NL', { style: 'currency', currency: 'EUR' }).format(c / 100); } catch (e) { return '€' + (c / 100).toFixed(2); } }
  function box(on){
    var d = document.createElement('div');
    d.className = 'lp-box' + (on ? ' on' : '');
    d.innerHTML = '<span class="lp-ic">' + shield + '</span><span class="lp-tx"><b>' + t.title + '<em>' + fmt(PRICE) + '</em></b><small>' + t.desc + '</small></span>' +
      '<label class="lp-sw"><input type="checkbox"' + (on ? ' checked' : '') + ' aria-label="' + t.title + '"><i></i></label>';
    return d;
  }
  function getCart(){ return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }); }
  function isCartPage(){ return document.body.classList.contains('template-cart'); }

  function rerenderDrawer(c){
    /* Let the theme re-render the drawer: a no-op quantity change on line 1. */
    if (!c.items.length) return;
    var b = document.createElement('button');
    b.type = 'button'; b.hidden = true;
    b.setAttribute('data-line', '1'); b.setAttribute('data-line-qty', String(c.items[0].quantity));
    document.body.appendChild(b); b.click(); b.remove();
  }

  function decorate(container, c, linesRoot){
    if (!container || container.querySelector('.lp-box')) return;
    var others = c.items.filter(function(i){ return i.variant_id !== VARIANT; });
    var idx = c.items.findIndex(function(i){ return i.variant_id === VARIANT; });
    if (!others.length) {
      if (idx > -1 && !busy) { busy = true; fetch('/cart/change.js', { method: 'POST', headers: J, body: JSON.stringify({ id: String(VARIANT), quantity: 0 }) }).then(function(){ busy = false; if (isCartPage()) location.reload(); else getCart().then(rerenderDrawer); }); }
      return;
    }
    var lines = (linesRoot || container).querySelectorAll('.line');
    if (idx > -1 && lines[idx]) lines[idx].classList.add('lp-line');
    var b = box(idx > -1);
    var bar = container.querySelector('.ship-bar');
    if (bar) bar.after(b); else container.prepend(b);
    b.querySelector('input').addEventListener('change', function(e){
      var on = e.target.checked; busy = true; b.classList.add('wait'); b.classList.toggle('on', on);
      var req = on
        ? fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1 }] }) })
        : fetch('/cart/change.js', { method: 'POST', headers: J, body: JSON.stringify({ id: String(VARIANT), quantity: 0 }) });
      req.then(function(){ return getCart(); }).then(function(nc){
        busy = false;
        if (isCartPage()) { location.reload(); return; }
        rerenderDrawer(nc);
      }).catch(function(){ busy = false; b.classList.remove('wait'); });
    });
  }

  /* Cart drawer: decorate after every render by the theme. */
  var body = document.getElementById('ak-cart-body');
  if (body) {
    new MutationObserver(function(){
      if (busy || body.querySelector('.lp-box') || !body.querySelector('.line')) return;
      getCart().then(function(c){ decorate(body, c); });
    }).observe(body, { childList: true });
  }

  /* Cart page. */
  function initPage(){
    if (!isCartPage()) return;
    var col = document.querySelector('.cart-page > div');
    if (col) getCart().then(function(c){ decorate(col, c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();
})();
